import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { ShowException } from 'store/Application/appActions'
import { GetContext } from 'store/storeUtils'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'

export const saveBomItemComment = createAsyncThunk<any, any, { state: any }>(
  'bom/saveComment',
  async (
    { bomItemId, comment }: { bomItemId: string; comment: string },
    thunkAPI
  ) => {
    const bomItemController = new BomItemController()

    const { projectId } = GetContext()

    try {
      if (thunkAPI.getState().project.activeProject?.id === bomItemId) {
        thunkAPI.dispatch(
          newProjectActions.setActiveProjectProperties({
            comment: comment,
          })
        )
      } else {
        thunkAPI.dispatch(
          newProjectActions.setBomItemProperties({
            id: bomItemId,
            comment: comment.trim(),
          })
        )
      }

      await bomItemController.updateComment(bomItemId, comment.trim())
    } catch (err) {
      ShowException('project', err)
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
